import React from "react";
import { useLocation } from "react-router-dom";

const External: React.FC = (props) => {
    const loc = useLocation();
    window.location = (loc.state as any).url;
    return <></>;
};

export default External;
